/**
 * Formats a number or a string that can be converted to a number, according to the specified language and precision.
 *
 * @param {string | number} value - The value to be formatted. It can be a number or a string that
 * can be converted to a number.
 * @param {string} [language='en'] - The language code to be used for formatting. Default is 'en' (English).
 * @param {number} [precision=0] - The maximum number of fraction digits to use. Default is 0.
 * @param {function} [parsevalue=(f: number) => f] - A function to parse the value before formatting.
 * Default is a function that returns the input value as is.
 * @returns {string} The formatted number as a string. If the input value is not a number, not finite, or NaN,
 * an empty string is returned.
 */
const formatNumber = (value, language = 'en', precision = 0, parsevalue = (f) => f) => {
    // if value is string, convert to float number
    const valueInNumber = typeof value === 'string' ? parseFloat(value) : value;
    if (typeof valueInNumber !== 'number' || Number.isNaN(valueInNumber) || !Number.isFinite(valueInNumber))
        return '';
    // en-CA or fr-CA
    const locale = `${language}-CA`;
    try {
        const valueStr = new Intl.NumberFormat(locale, {
            maximumFractionDigits: precision,
        }).format(parsevalue(valueInNumber));
        return valueStr;
    }
    catch (error) {
        return '';
    }
};
export default formatNumber;
